import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TeamsComponent} from './teams/teams.component';
import {LoginComponent} from './login/login.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {DeviceRegisterComponent} from './device-register/device-register.component';
import {ReportsComponent} from './reports/reports.component';
import {RegisterComponent} from "./register/register.component";
import {SettingsComponent} from "./settings/settings.component";

const routes: Routes = [
    {path: '', component: DashboardComponent},
    {path: 'login', component: LoginComponent},
    {path: 'settings', component: SettingsComponent},
    {path: 'register', component: RegisterComponent},
    {path: 'device-register', component: DeviceRegisterComponent},
    {path: 'reports', component: ReportsComponent},
    {path: 'teams', component: TeamsComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
    public static ROUT: Routes = routes;
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts